const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
export function isoDate(value) {
    const match = ISO_DATE_RE.exec(value);
    if (!match) {
        throw new RangeError(`IsoDate must be formatted YYYY-MM-DD, received: ${value}`);
    }
    const [, y, m, d] = match;
    const year = Number(y);
    const month = Number(m);
    const day = Number(d);
    const parsed = new Date(Date.UTC(year, month - 1, day));
    if (parsed.getUTCFullYear() !== year ||
        parsed.getUTCMonth() !== month - 1 ||
        parsed.getUTCDate() !== day) {
        throw new RangeError(`IsoDate is not a real calendar date: ${value}`);
    }
    return value;
}
export function isIsoDate(value) {
    try {
        isoDate(value);
        return true;
    }
    catch {
        return false;
    }
}
export function taxYear(startYear) {
    if (!Number.isInteger(startYear) || startYear < 2000 || startYear > 2100) {
        throw new RangeError(`TaxYear start must be a plausible integer year, received: ${startYear}`);
    }
    return startYear;
}
/** Human label for a UK tax year, e.g. 2025 -> "2025/26". */
export function formatTaxYear(year) {
    const end = (year + 1) % 100;
    return `${year}/${end.toString().padStart(2, '0')}`;
}
//# sourceMappingURL=date.js.map